<div id="company-filters">

  <div class="row">
    <p class="title">Proprietários e empresas</p>
    <a class="clean-filters">Limpar</a>
  </div>

  <div class="row">
    <app-input id="empreendimento" class="one-half" label="Empreendimento" placeholder="">
    </app-input>
    <app-input id="empresa" class="one-half" label="Empresa Lopes" placeholder="">
    </app-input>
  </div>

  <div class="row">
    <app-input id="condominio" class="one-half" label="Condomínio" placeholder="">
    </app-input>
    <app-input id="incorporador" class="one-half" label="Incorporador" placeholder="">
    </app-input>
  </div>

  <div class="row">
    <!-- <app-input id="cpf-proprietario" class="one-quarter" label="CPF do proprietário" maskInput="000.000.000-00" placeholder="">
    </app-input> -->

    <!-- <app-flag-input class="one-quarter" label="Telefone da administradora"></app-flag-input> -->

    <app-input id="email-proprietário" class="one-half" type="email" label="E-mail do proprietário" placeholder="">
    </app-input>
  </div>

</div>